import Account from "@/helper/AccountHelper.js";

export default {
    data: function () {
        return {
            isAccountLoaded: false,
            isLogin: false,
            user: {},
            profile: {},
            point: 0,
            pointDate: 0
        };
    },
    created: function () {
        Account.loginStatus().then((status) => {
            this.isLogin = status;
            this.getAccountData();

            if (typeof this.accountInitiated == 'function') {
                this.accountInitiated();
            }
        }).finally(() => {
            this.isAccountLoaded = true;
        });

        var body = document.querySelector('body');
        body.classList.remove('body-noscroll');
        
    },
    methods: {
        getToken: function () {
            return Account.getToken();
        },
        getAccountData: function () {
            this.user = Account.getCacheUser();
            this.profile = Account.getCacheProfile() || {};
            this.point = Account.getCachePoint();
            this.pointDate = Account.getCachePointUpdateDate();
        },
        //point
        getExpiringPoint: function () {
            return Account.apiGetExpiringPoint();
        },
        getUserPoint: function () {
            this.point = Account.getCachePoint();
        },
        getUserLastestPoint: function () {
            Account.apiGetPoint().then((data) =>{
                console.log("point", data.points);
                this.updateUserPoint(data);
                this.$store.commit("setPoint", data);
            });
        },
        updateUserPoint: function (updatedPoint) {
            if (!updatedPoint) return;

            Account.updatePoint(updatedPoint);
            this.getUserPoint();
        },
        //info
        getPictureLine: function (){
            var userCache = Account.getCacheUser();
            if(userCache && userCache.line){
                this.isLine = true;
                this.linePicture = userCache.line.pictureUrl;
            }
            return this.linePicture;
        },
        getProfileAddress: function () {
            return Account.getCacheProfileAddress();
        }
    }
}
